const TWO_MINUTES = 2*60*1000

export const startPolling = (op:any, interval:number) => {
	op.startPolling(interval||TWO_MINUTES)
	return () => {
		op.stopPolling()
	}
}